// This file contains constants used by appDesigner that need to be imported
// by reducers. It's separated to avoid circular dependencies.

export const colorKeys = {
    textAndIconOnBackgroundColor: 'textAndIconOnBackgroundColor',
    textAndIconOnCardColor: 'textAndIconOnCardColor',
    backgroundColor: 'backgroundColor',
    cardsPanelsColor: 'cardsPanelsColor',
    secondaryCardsPanelsColor: 'secondaryCardsPanelsColor',
    textAndIconOnSecondaryCardsPanelsColor:
        'textAndIconOnSecondaryCardsPanelsColor',
    linesDividersColor: 'linesDividersColor',
    alertsWarningsColor: 'alertsWarningsColor',
    confirmationsColor: 'confirmationsColor',
    textAndIconOnAccentColor: 'textAndIconOnAccentColor',
    textAndIconOnAlertsWarningsColor: 'textAndIconOnAlertsWarningsColor',
    accentColor: 'accentColor',
};

// Background type constants
export const BACKGROUND_TYPES = {
    COLOR: 'Color',
    GRADIENT: 'Gradient',
    IMAGE: 'Image',
    NONE: 'None',
};

// Mapping of widget style color fields to event theme color properties
export const widgetColorToThemeColorMap = {
    fontColor: colorKeys.textAndIconOnCardColor,
    backgroundColor: colorKeys.cardsPanelsColor,
    secondaryCardsPanelsColor: colorKeys.secondaryCardsPanelsColor,
    textAndIconOnSecondaryCardsPanelsColor:
        colorKeys.textAndIconOnSecondaryCardsPanelsColor,
    textAndIconOnBackgroundColor: colorKeys.textAndIconOnBackgroundColor,
    accentColor: colorKeys.accentColor,
    textAndIconOnAccentColor: colorKeys.textAndIconOnAccentColor,
};

// Default advanced color configuration for event styles
export const DEFAULT_ADVANCED_COLORS_LIGHT = {
    [colorKeys.textAndIconOnBackgroundColor]: '#021231',
    [colorKeys.textAndIconOnCardColor]: '#021231',
    [colorKeys.backgroundColor]: '#F0F5FE',
    [colorKeys.linesDividersColor]: '#E1EBFE',
    // TODO: pending below colors mapping
    [colorKeys.accentColor]: '#0054FF',
    [colorKeys.textAndIconOnAccentColor]: '#FFFFFF',
    [colorKeys.cardsPanelsColor]: '#FFFFFF',
    [colorKeys.secondaryCardsPanelsColor]: '#F5F5F5',
    [colorKeys.textAndIconOnSecondaryCardsPanelsColor]: '#021231',
    [colorKeys.alertsWarningsColor]: '#F62213',
    [colorKeys.textAndIconOnAlertsWarningsColor]: '#FFFFFF',
    [colorKeys.confirmationsColor]: '#13F622',
};

export const DEFAULT_ADVANCED_COLORS_DARK = {
    [colorKeys.textAndIconOnBackgroundColor]: '#CEDEFD',
    [colorKeys.textAndIconOnCardColor]: '#CEDEFD',
    [colorKeys.backgroundColor]: '#010E27',
    [colorKeys.linesDividersColor]: '#042362',
    // TODO: pending below colors mapping
    [colorKeys.accentColor]: '#145ef7',
    [colorKeys.cardsPanelsColor]: '#021945',
    [colorKeys.secondaryCardsPanelsColor]: '#032A6B',
    [colorKeys.textAndIconOnSecondaryCardsPanelsColor]: '#CEDEFD',
    [colorKeys.alertsWarningsColor]: '#F63913',
    [colorKeys.textAndIconOnAlertsWarningsColor]: '#021945',
    [colorKeys.confirmationsColor]: '#13F622',
    [colorKeys.textAndIconOnAccentColor]: '#FFFFFF',
};

// Default eventStyles structure matching the hook's default
export const DEFAULT_EVENT_STYLES = {
    styleMode: 'light',
    themeColors: {
        light: DEFAULT_ADVANCED_COLORS_LIGHT,
        dark: DEFAULT_ADVANCED_COLORS_DARK,
    },
    selectedThemeId: 'blue',
    accentColor: '#0054FF',
};
